define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	const poAdminRoles = ['Purchase Order Administrator'];
	const poEditRoles = poAdminRoles.concat(['Purchase Order Editor']);
	const poRoles = poEditRoles.concat(['Purchase Order Viewer']);
	const plAdminRoles = ['PackList Administrator'];
	const plCreatorRoles = plAdminRoles.concat(['PackList Creator']);
	const plEditorRoles = plCreatorRoles.concat(['PackList Editor']);
	const shipmentAdminRoles = ['Shipment Administrator'];
	const shipmentEditRoles = shipmentAdminRoles.concat(['Shipment Editor']);
	const shipmentRoles = shipmentEditRoles.concat(['Shipment Viewer']);
	const securityGroupAdminRoles = ['Security Group Administrator'];
	const sourcingLibAdminRoles = ['Sourcing Library Administrator'];
	const sizeCurveAdminRoles = sourcingLibAdminRoles.concat(['Product Specification Library Administrator']);

	csiAccess.addViewRoles({
		"LibSourcing":{
			"CustomerPurchaseOrders":{
				"NewCustomerPurchaseOrder":access(full(poAdminRoles))
			},
			"PackLists":{
				"NewPackList":access(full(plCreatorRoles)),
				"NewPackListWithPO":access(full(plCreatorRoles)),
				"Delete":access(full(plAdminRoles))
			},
			"PurchasedOrders":{
				"Copy":access(full(poEditRoles)),
				"NewPurchasedOrder":access(full(poEditRoles)),
				"NewPurchasedOrderFromSalesOrder":access(full(poEditRoles))
			},
			"PurchasedOrderGroups":{
				"Delete":access(full(securityGroupAdminRoles)),
				"NewPurchasedOrderGroup":access(full(securityGroupAdminRoles))
			},
			"ShipmentTerms":{
				"NewPackList":access(full(plCreatorRoles)),
				"NewPackListWithPO":access(full(plCreatorRoles)),
				"NewShipmentTerms":access(full(shipmentEditRoles))
			}
		},
		"PackList": {
			"PackListHeader":{
				"SubmitPackList":access(full(plEditorRoles)),
				"RejectPackList":access(full(plAdminRoles)),
				"ApprovePackList":access(full(plAdminRoles)),
				"AbandonPackListFromDraft":access(full(plCreatorRoles)),
				"AbandonPackList":access(full(plAdminRoles)),
				"ReopenPackListFromAbandoned":access(full(plAdminRoles))
			},
			"Cartons": {
				"ResetCartons":access(full(plEditorRoles))
			}
		},
		"Product":{
			"PurchasedOrders":{
				"Copy":access(full(poEditRoles)),
				"NewPurchasedOrder":access(full(poEditRoles)),
				"NewPurchasedOrderFromSalesOrder":access(full(poEditRoles))
			}
		},
		"PurchasedOrder":{
			"Shipment":{
				"NewPackList":access(full(plCreatorRoles)),
				"NewPackListWithPO":access(full(plCreatorRoles))
			}
		},
		"ShipmentTerms":{
			"ShipmentTerms":{
				"Freeze|Child:__Parent__":access(full(poEditRoles)),
				"Unfreeze|Child:__Parent__":access(full(poAdminRoles))
			},
			"ShipmentTermsPackLists":{
				"NewPackList":access(full(plCreatorRoles)),
				"NewPackListWithPO":access(full(plCreatorRoles))
			}
		},
		"SizeRange":{
			"SizeCurves":{
				"ApproveSizeCurve": access(full(sizeCurveAdminRoles)),
				"Copy":access(full(sizeCurveAdminRoles)),
				"Delete":access(full(sizeCurveAdminRoles)),
				"NewSizeCurve":access(full(sizeCurveAdminRoles))
			}
		},
		"Supplier":{
			"ShipmentTerms":{
				"NewShipmentTerms":access(full(shipmentEditRoles))
			}
		},
		"_CS_Data":{
			"PurchasedOrders":{
				"Freeze":access(full(poAdminRoles)),
				"Delete":access()
			}
		}
	});
});